import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  bills: [],
  currentBill: null,
  loading: false,
  error: null,
  emailStatus: {
    sending: false,
    error: null
  },
  filters: {
    dateRange: {
      start: null,
      end: null
    },
    status: 'all'
  },
  // Month End Close state
  billingPeriods: [],
  currentPeriod: null,
  billingConfig: null,
  periodsLoading: false,
  periodsError: null,
  periodValidation: null
};

const billingSlice = createSlice({
  name: 'billing',
  initialState,
  reducers: {
    setBills: (state, action) => {
      state.bills = action.payload;
      state.error = null;
    },
    setCurrentBill: (state, action) => {
      state.currentBill = action.payload;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      // Only set error if it's different from current error to prevent unnecessary re-renders
      if (state.error !== action.payload) {
        state.error = action.payload;
      }
      state.loading = false;
    },
    addBill: (state, action) => {
      state.bills.unshift(action.payload);
      state.error = null;
    },
    updateBill: (state, action) => {
      const index = state.bills.findIndex(bill => bill.id === action.payload.id);
      if (index !== -1) {
        state.bills[index] = action.payload;
      }
      if (state.currentBill?.id === action.payload.id) {
        state.currentBill = action.payload;
      }
      state.error = null;
    },
    emailBillStart: (state) => {
      state.emailStatus.sending = true;
      state.emailStatus.error = null;
    },
    emailBillSuccess: (state) => {
      state.emailStatus.sending = false;
      state.emailStatus.error = null;
    },
  emailBillFailure: (state, action) => {
      state.emailStatus.sending = false;
      state.emailStatus.error = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    // Month End Close reducers
    setBillingPeriods: (state, action) => {
      state.billingPeriods = action.payload;
      state.periodsError = null;
    },
    setCurrentPeriod: (state, action) => {
      state.currentPeriod = action.payload;
      state.periodsError = null;
    },
    updatePeriod: (state, action) => {
      const index = state.billingPeriods.findIndex(p => p.id === action.payload.id);
      if (index !== -1) {
        state.billingPeriods[index] = action.payload;
      }
      if (state.currentPeriod?.id === action.payload.id) {
        state.currentPeriod = action.payload;
      }
    },
    setBillingConfig: (state, action) => {
      state.billingConfig = action.payload;
    },
    setPeriodsLoading: (state, action) => {
      state.periodsLoading = action.payload;
    },
    setPeriodsError: (state, action) => {
      state.periodsError = action.payload;
      state.periodsLoading = false;
    },
    setPeriodValidation: (state, action) => {
      state.periodValidation = action.payload;
    },
    clearPeriodValidation: (state) => {
      state.periodValidation = null;
    }
  }
});

export const {
  setBills,
  setCurrentBill,
  setLoading,
  setError,
  addBill,
  updateBill,
  emailBillStart,
  emailBillSuccess,
  emailBillFailure,
  setFilters,
  // Month End Close actions
  setBillingPeriods,
  setCurrentPeriod,
  updatePeriod,
  setBillingConfig,
  setPeriodsLoading,
  setPeriodsError,
  setPeriodValidation,
  clearPeriodValidation
} = billingSlice.actions;

export default billingSlice.reducer;
